import { MenuList, Stack } from "@mui/material";
import ConversationList from "components/chat-v2/ConversationList";
import ConversationV2 from "components/chat-v2/ConversationV2";
import NewConversationButton from "components/chat-v2/NewConversationButtonV2";
import useIsMobile from "hooks/react-lib/generic-ui/useIsMobile";
import ConversationDrawerMenu from "components/menus/ConversationDrawerMenu";
import View from "./View";
import ConversationsLoader from "components/data/ConversationsLoader";
import CurrentBotHeader from "components/bot/CurrentBotHeader";

export default function ChatViewV2() {

  const CONVERSATION_LIST_WIDTH = 300;
  const isMobile = useIsMobile();
  
  return (
    <View
      renderLeftActions={() => {
        return <CurrentBotHeader />
      }}
      renderRightActions={() => {
        return <ConversationDrawerMenu />;
      }}
    >
      <ConversationsLoader />
      {!isMobile && ( // Only render conversations on desktop
        <Stack p={1}>
          <Stack px={2} pb={1}>
            <NewConversationButton />
          </Stack>
          <MenuList
            sx={{
              height: "95%", // A bit hacky, we should fix this
              width: `${CONVERSATION_LIST_WIDTH}px`,
              overflowY: "auto",
              overflowX: "none",
              boxSizing: "border-box",
            }}
          >
            <ConversationList />
          </MenuList>
        </Stack>
      )}
      <Stack
        sx={{
          width: `calc(100% - ${isMobile ? 0 : CONVERSATION_LIST_WIDTH}px)`,
          height: "100%",
          overflow: "auto",
        }}
      >
        <ConversationV2 />
      </Stack>
    </View>
  );
}
